import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { UrlResolver } from '@elotech/angular-common';
import { HttpClient } from '@elotech/angular-common';

@Injectable()
export class AuthComponentService {
  constructor(
    private httpClient: HttpClient,
    private urlResolver: UrlResolver
  ) {}

  getUrlBrasao() {
    return `${this.urlResolver.getUrlResolved()}/rest/entidades/principal/brasao`;
  }

  getCidade(): Observable<any> {
    return this.httpClient.get({
      resource: '/rest/entidades/principal/entidade',
      fields: 'cidade.descricao'
    });
  }
}
